export default "__VITE_ASSET__3f0a4381__"